document.addEventListener("DOMContentLoaded", function () {
  // --- Desktop tabs nav ---
  const vimeoPlayers = Array.from(
    document.querySelectorAll('iframe[id^="vimeo-player-"]')
  ).map((iframe) => new window.Vimeo.Player(iframe));

  function pauseAllVideos() {
    vimeoPlayers.forEach((player) => {
      player.getPaused().then((paused) => {
        if (!paused) player.pause();
      });
    });
  }

  document
    .querySelectorAll('#myTab button[data-bs-toggle="tab"]')
    .forEach((btn) => btn.addEventListener("shown.bs.tab", pauseAllVideos));

  document
    .querySelectorAll("#storiesAccordion .accordion-button")
    .forEach((btn) => {
      const targetId = btn.getAttribute("data-bs-target");
      document
        .querySelector(targetId)
        .addEventListener("show.bs.collapse", pauseAllVideos);
    });
});
